import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const ComparisonViewWrap = styled(Box)(`
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	border: 1px solid #D8D8D6;
	border-radius: 4px;
	margin-bottom: 12px;
	justify-content: flex-start;
	
	&.expanded {
		// height: 545px;
		.graph { display: block; }
		.button:after {display:none;}
		.button:hover:after {display:block;}
	}
	
	&.collapsed {
		height: 36px;
		.graph{display: none;}
	}

	& .button {
		cursor: pointer;
		border: 0;
		position: absolute;
		top: 7px;
		right: 7px;
		width: 20px;
		height: 20px;
		background: #EFEFEF;
		border-radius: 4px;
		
		display: flex;
		justify-content: center;
		align-items: center;

		&:before, &:after {
			content: '';
			width: 10px;
			height: 1px;
			background: #686867;
			position: absolute;
			top: 10px;
			left: 5px;
			display: block;
		}
		&:after {
			transform: rotate(90deg);
		}
	}
	& .button:hover {
		&:after {display:none;}
	}
`)

export const Title = styled(Box)(`
	position: relative;
	font-size: 16px;
	font-weight: 600;
	width: 100%;
	height: 36px;
	line-height: 36px;
	padding-left: 8px;
`)

export const HeadingButton = styled(Box)(`
	width: 100%;
	height: 36px;
	line-height: 36px;
	cursor: pointer;
`)

